import {Timeout} from 'components/common/Timeout'
import moment from 'moment'
import React, {useEffect, useState} from 'react'
import {OrderProvider} from './OrderProvider'

type Props = {
  children: React.ReactNode
  showTimeoutScreen: boolean
}

export const TimeoutContext = React.createContext(null)

export const TimeoutProvider = ({children, showTimeoutScreen}: Props) => {
  const order = OrderProvider.useOrder('optional')
  const setOrder = OrderProvider.useOrderSetter()

  const expiresIn =
    order === null || order.status === 'CONFIRMED'
      ? null
      : moment.utc(order.utcExpiresAt).diff(moment(), 'milliseconds')

  const [timeIsUp, setTimeIsUp] = useState(expiresIn !== null && expiresIn <= 0)

  useEffect(() => {
    if (expiresIn === null) {
      return
    }

    if (expiresIn <= 0) {
      setOrder(null)
      setTimeIsUp(true)
      return
    }

    const timeoutId = setTimeout(() => {
      setOrder(null)
      setTimeIsUp(true)
    }, expiresIn)

    return () => clearTimeout(timeoutId)
  }, [expiresIn, setOrder, setTimeIsUp])

  if (showTimeoutScreen && timeIsUp) {
    return <Timeout />
  }

  return <TimeoutContext.Provider value={null}>{children}</TimeoutContext.Provider>
}
